var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "members__item" }, [
    _c(
      "a",
      {
        staticClass: "picture-morph",
        attrs: { href: "/participants-page/" + _vm.member.id }
      },
      [
        _c("BaseLazyLoadingimg", {
          staticClass: "picture-morph__img",
          attrs: { srcSet: [_vm.srcset[0], _vm.srcset[1], _vm.srcset[2]] }
        }),
        _c("div", { staticClass: "picture-morph__wrap" }, [
          _c(
            "svg",
            {
              staticClass: "picture-morph__svg",
              attrs: {
                width: "10",
                height: "10",
                viewBox: "0 0 10 10",
                preserveAspectRatio: "none"
              }
            },
            [
              _c("path", {
                ref: "start",
                staticClass: "picture-morph__path",
                attrs: {
                  d:
                    "M 10 10 L 10 10 C 10 10 10 10 5 10 C 0 10 0 10 0 10 L 0 10 Z"
                }
              })
            ]
          )
        ]),
        _c(
          "div",
          { ref: "content", staticClass: "picture-morph__content" },
          [
            _c("BaseCaption", { attrs: { text: _vm.member.memberName } }),
            _c("BaseText", { attrs: { text: _vm.member.memberDescr } })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ffe38902", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffe38902","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/MembersListItem.vue
// module id = wcET
// module chunks = 0